module.exports = __webpack_public_path__ + "static/img/product5.c12efbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product5.png
// module id = UZDf
// module chunks = 1